import { AppSettingContext } from 'contexts'
import { useContext } from 'react'
import { AppSetting } from 'services/types'

export const useSettingService = () => {
    const settingsContext = useContext(AppSettingContext)

    const setSetting = (key: string, value: any): void => settingsContext.appSettings.put({ id: key, value: value })
    const getSettingByKey = (key: string): AppSetting | undefined => settingsContext.appSettings.get(key)
    const deleteSettingByKey = (key: string): void => settingsContext.appSettings.remove(key)

    const getTrainingMode = (): boolean => getSettingByKey('isTrainingMode')?.value ?? false
    const setTrainingMode = (state: boolean): void => setSetting('isTrainingMode', state)
    const deleteTrainingModeKey = (): void => deleteSettingByKey('isTrainingMode')

    const getTrainerId = (): string | undefined => getSettingByKey('trainerId')?.value;
    const setTrainerId = (value: string | undefined): void => setSetting('trainerId', value);
    const deleteTrainerIdKey = (): void => deleteSettingByKey('trainerId')

    const setAppUpdated = (value: boolean): void => setSetting('isAppUpdated', value);
    const getAppUpdated = (): boolean => getSettingByKey('isAppUpdated')?.value ?? false
    const deleteAppUpdated = (): void => deleteSettingByKey('isAppUpdated')

    const getAppVersion = (): string | undefined => getSettingByKey('appVersion')?.value;
    const setAppVersion = (value: string | undefined): void => setSetting('appVersion', value);
    const deleteAppVersion = (): void => deleteSettingByKey('appVersion')

    const clearSettings = (): void => {
        deleteTrainerIdKey
        deleteTrainingModeKey
        deleteSettingByKey
        deleteAppUpdated
        deleteAppVersion
    }

    const updateSettings = (appSettings: AppSetting[]): void => {
        appSettings.forEach(s => {
            switch (s.id) {
                case "isTrainingMode": setTrainerId(s.value); break;
                case "accessToken": setTrainingMode(s.value); break;
                case "isAppUpdated": setAppUpdated(s.value); break;
                case "appVersion": setAppVersion(s.value); break;
                default: null;
            }
        })
    }

    return {
        getTrainingMode: getTrainingMode,
        setTrainingMode: setTrainingMode,
        getTrainerId: getTrainerId,
        setTrainerId: setTrainerId,
        getAppUpdated: getAppUpdated,
        setAppUpdated: setAppUpdated,
        getAppVersion: getAppVersion,
        setAppVersion: setAppVersion,
        deleteTrainerIdKey: deleteTrainerIdKey,
        deleteTrainingModeKey: deleteTrainingModeKey,
        deleteAppUpdated: deleteAppUpdated,
        deleteAppVersion: deleteAppVersion,
        clearSettings: clearSettings,
        updateSettings: updateSettings
    }
}
